module.exports = __webpack_public_path__ + "img/whale.52d2371d.svg";